import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import {
  KpiGradient, EvolutionCard, ParcoursCard, NosPanneauxCard, RevenuTotalCard,
  SmallKpis, RevenusParType, DistributionContrats, ProspectsParStatut,
} from '../components/dashboard/DashboardBlocks';

export default function Dashboard({ user, onLogout }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get('/dashboard/overview').then((r) => setData(r.data)).catch(() => setError(true));
  }, []);

  if (!data) {
    return (
      <Layout user={user} onLogout={onLogout} currentPage="dashboard">
        <div className="flex items-center justify-center h-96 text-slate-500" data-testid="dashboard-loading">
          {error ? 'Impossible de charger le tableau de bord.' : <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />}
        </div>
      </Layout>
    );
  }

  const taux = String(data.taux_conversion).replace('.', ',');
  return (
    <Layout user={user} onLogout={onLogout} currentPage="dashboard">
      <div className="space-y-4 pb-6" data-testid="dashboard-stats">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          <KpiGradient testid="kpi-total-prospects" title="Total prospects" value={data.total_prospects} sub="Votre réserve commerciale" from="#2f5be8" to="#4f7cf7" />
          <KpiGradient testid="kpi-total-clients" delay={60} title="Total clients" value={data.total_clients} sub="Prospects devenus clients" from="#2f5be8" to="#4f7cf7" />
          <KpiGradient testid="kpi-contrats-actifs" delay={120} title="Contrats actifs" value={data.contrats_actifs} sub="En cours de diffusion" from="#2f5be8" to="#4f7cf7" />
          <KpiGradient testid="kpi-taux-conversion" delay={180} title="Taux de conversion" value={`${taux} %`} sub={`${data.total_clients} clients sur ${data.total_prospects} prospects`} from="#2f5be8" to="#4f7cf7" />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,2.6fr)_minmax(0,1fr)] gap-4 items-start">
          <div className="space-y-4">
            <EvolutionCard data={data} />
            <NosPanneauxCard data={data} />
          </div>
          <div className="space-y-4">
            <ParcoursCard data={data} />
            <RevenuTotalCard data={data} />
          </div>
        </div>

        <SmallKpis data={data} />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <RevenusParType data={data} />
          <DistributionContrats data={data} />
          <ProspectsParStatut data={data} />
        </div>

        <p className="text-right text-xs text-slate-500" data-testid="dashboard-footnote">
          Prix / jour : moyenne de vos grilles tarifaires{data.grilles?.length ? ` (${data.grilles.join(', ')})` : ''}
          {data.types_sans_tarif?.length ? ` · sans tarif : ${data.types_sans_tarif.join(', ')}` : ''}
        </p>
      </div>
    </Layout>
  );
}
